

















































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { Action, Mutation, Getter } from "vuex-class";
import { SEARCH_INS_USER } from "@/store/constants/ins_user_info_types";
import Popup from "@/components/Popup/Popup.vue";
import LoginButton from "@/components/LoginButton/LoginButton.vue";
import InputField from "@/components/InputField/InputField.vue";
import "@/assets/icons-file/login/lh_app_ins_shape.svg";
import { goToLogin } from "@/utils/router_helper";
import { isEmail, isIos } from "@/utils/lodash";
import BottomGroup from "./BottomGroup.vue";
// import ListenNative from "@/jsbridge/service/listenNative";
// import jsBridge from "@/jsbridge/index";
@Component({
  components: {
    Popup,
    LoginButton,
    InputField,
    BottomGroup
  }
})
export default class LiteSearch extends Vue {
  @Action(SEARCH_INS_USER)
  private searchInsUser: any;
  @Prop()
  private value?: boolean;
  @Prop()
  private from!: any;

  private buttonStatus: string = "normal";
  private popShow: boolean = false;
  private accountText = "";
  private timer: any;

  private showWarnLine = false;
  private keyBoardListener: any = null;

  @Watch("value", { immediate: false })
  private changePop(val: boolean, oldVal: boolean) {
    this.popShow = val;
  }

  @Watch("popShow", { immediate: false })
  private change(val: boolean, oldVal: boolean) {
    this.$emit("input", val);
    this.accountText = "";
  }

  private clearLoginOffer() {
    // loginBuyOffer.setOffer(null);
  }

  // private async addKeyBoardListen() {
  //   this.keyBoardListener = await ListenNative.addListen(
  //     "keyboard",
  //     (data: any) => {
  //       const { type, end_frame } = data;
  //       if (type === "will_show" && this.popShow && end_frame.h) {
  //         // console.log("will_show:", {
  //         //   end_frame: end_frame.h
  //         // });
  //         document.body.scrollTop = end_frame.h;
  //         document.documentElement.scrollTop = end_frame.h;
  //       }
  //       if (type === "will_hide" && this.popShow) {
  //         // console.log("will_hide:", {
  //         //   popShow: this.popShow
  //         // });
  //         document.body.scrollTop = 0;
  //         document.documentElement.scrollTop = end_frame.h;
  //       }
  //     }
  //   );
  // }

  private clearKeyBoardListen() {
    // Jsbridge.removeListen(this.keyBoardListener);
  }

  private mounted() {
    // this.addKeyBoardListen();
    // this.listenSwitchBackground();
  }

  // private listenSwitchBackground() {
  //   ListenNative.addListen("did_enter_background", () => {
  //     jsBridge.hideKeyboard();
  //   });
  // }

  private clolsePopup(val?: any) {
    const inputFiled: any = this.$refs.inputFiled;
    if (inputFiled && inputFiled.$el) {
      const input = inputFiled.$el.querySelector("#input-dom");
      input && input.blur();
    }
    this.$emit("input", false);
    if (val) {
      this.clearLoginOffer();
    }
  }

  private showRedLine() {
    this.showWarnLine = true;
    setTimeout(() => {
      this.showWarnLine = false;
    }, 2000);
  }

  private async clickStarted(item: any, index: any) {
    const accountText = this.accountText.replace(/\s*/g, ""); // 去除空格
    if (accountText === "") {
      this.$_Toast.show({
        duration: 2000,
        text: "Please enter your Instagram username first."
      });
      this.showRedLine();
      return;
    } else if (isEmail(accountText)) {
      this.$_Toast.show({
        duration: 2000,
        text: "Please enter your Instagram username, not email."
      });
      this.showRedLine();
      return;
    }
    try {
      this.buttonStatus = "loading";
      await this.searchInsUser(accountText);
      this.buttonStatus = "normal";
      this.clolsePopup();
    } catch (error) {
      this.buttonStatus = "normal";
      this.errorHandle(error);
      this.showRedLine();
    }
  }

  private toastNetWorkError() {
    this.$_Toast.show({
      duration: 2000,
      text: "Please check your network and try again later."
    });
  }

  private errorHandle(error: any) {
    const { error_type, message } = error;
    if (
      error_type === "user_not_found" ||
      (typeof error === "string" && error.includes("html") && !isIos()) ||
      (typeof error === "string" && isIos())
    ) {
      // unvalid comma string of username:
      this.$_Toast.show({
        duration: 2000,
        text: "Please check your username and try again."
      });
    } else if (message === "login_required") {
      this.clolsePopup();
    } else {
      // native error or ins error
      this.toastNetWorkError();
    }
  }

  private loginWithInstragram() {
    this.clolsePopup();
    goToLogin();
  }
}
